import React from "react";
import { useI18n } from "@/context/I18nContext";

const TONES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  blue: "bg-blue-50 text-blue-700 border-blue-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
  gray: "bg-gray-100 text-gray-600 border-gray-200",
  orange: "bg-brand-soft text-brand border-orange-200",
};

export function StatusBadge({ value, map, testid }) {
  const { t } = useI18n();
  const conf = (map && map[value]) || { label: value || "-", tone: "gray" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 rounded-sm border text-xs font-medium whitespace-nowrap ${TONES[conf.tone] || TONES.gray}`}
    >
      {t(conf.label)}
    </span>
  );
}
